<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'calendar']"></fa-icon>
				</span>
				<span class="overview-title">Contract Term</span>
			</div>

			<div class="p-grid overview-detail">
				<div class="p-col-12">
					<div class="overview-number">{{ mainContract.monthsRemaining }} / {{ mainContract.durationMonths }}</div>
					<div class="overview-subtext">
						<div *ngIf="mainContract.autoRenew">auto-renew is on</div>
						<div *ngIf="!mainContract.autoRenew">auto-renew is off</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card no-gutter widget-overview-box widget-overview-box-2">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
				</span>
				<span class="overview-title">Contract Term</span>
			</div>

			<div class="p-grid overview-detail">
				<div class="col-6">
					<div class="overview-number">{{ app.moment(mainContract.startDate).format("l") }}</div>
					<div class="overview-subtext">
						<div>Start</div>
					</div>
				</div>
				<div class="col-6">
					<div class="overview-number">{{ app.moment(mainContract.endDate).format("l") }}</div>
					<div class="overview-subtext">
						<div>End</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-contract-list [(contract)]="contract"></app-contract-list>
<app-contract-record *ngIf="contract" [(contract)]="contract"></app-contract-record>
